module.exports = __webpack_public_path__ + "img/size_guide-header.13d38511.png";